<template>
  <tr
    class="tableTwoColumnsRow"
    :class="[
      { 'tableTwoColumnsRow--active': row.active },
      { 'tableTwoColumnsRow--minColumnTitle': minColumnTitle },
    ]"
  >
    <td class="tableTwoColumnsRow__cell tableTwoColumnsRow__cell--title">{{ row.title }}</td>
    <td class="tableTwoColumnsRow__cell tableTwoColumnsRow__cell--value">
      <router-link v-if="row?.to?.name" :to="row.to" class="text-link">{{ row.value }}</router-link>
      <template v-else class="">{{ row.value === null ? 'N/A' : row.value }}</template>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'GlTableTwoColumnsRow',
  props: {
    minColumnTitle: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTwoColumnsRow {
  $this: &;

  &:nth-child(odd) {
    background-color: rgba(255, 255, 255, 0.07);
  }

  &__cell {
    display: block;
    font-size: 13px;
    line-height: 20px;
    padding: 10px 16px;
    width: 100%;

    @media (min-width: $breakpoint-md) {
      display: table-cell;
      width: 50%;
    }

    &--title {
      color: rgba(255, 255, 255, 0.38);
      white-space: nowrap;

      @media (max-width: $breakpoint-md - 1px) {
        padding-bottom: 0;
      }
    }

    &--value {
      @include text-truncate;

      color: #fff;
      max-width: 1px; // for truncate text

      @media (max-width: $breakpoint-md - 1px) {
        min-width: 100%; // for truncate text
        padding-top: 0;
      }
    }
  }

  &--active {
    font-weight: 700;

    #{$this}__cell {
      &--title,
      &--value {
        color: $color-primary;
      }
    }
  }

  &--minColumnTitle {
    #{$this}__cell {
      &--title {
        @media (min-width: $breakpoint-md) {
          width: auto;
        }
      }

      &--value {
        @media (min-width: $breakpoint-md) {
          width: 100%;
        }
      }
    }
  }
}
</style>
